import * as UserActions from '../actions/UserActions'
import {PENDING, FULFILLED} from '../actions/constants';
import update from 'immutability-helper';

export default (state = {
    items: {},
    isFetching: [],
    isFetched: [],
    fetched: false,
    fetching: false,
    updating: false,
    active: null,
}, action) => {
    switch (action.type){
        case UserActions.FETCH_USERS + PENDING:
            return update(state, {
                fetching: {$set: true}
            });
        case UserActions.FETCH_USERS + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                fetching: {$set: false},
                fetched: {$set: true}
            });

        case UserActions.FETCH_USER + PENDING:
            return update(state, {
                isFetching: {[action.meta.key]: {$set: true}},
            });

        case UserActions.FETCH_USER + FULFILLED:
            let newState = {
                isFetched: {[action.meta.key]: {$set: true}},
                isFetching: {[action.meta.key]: {$set: false}},
                items: {$merge: action.payload}
            };

            if(action.meta.key && action.meta.key === "active"){
                const user = Object.values(action.payload)[0];
                newState.active = {$set: user};
            }
            return update(state, newState);

        case UserActions.UPDATE_USER + PENDING:
            return update(state, {
                updating: {$set: true}
            });

        case UserActions.UPDATE_USER + FULFILLED:
            const tmpState = update(state, {
                updating: {$set: false},
                items: {
                    [action.meta.key] : {$merge: action.payload}
                }
            });
            return update(tmpState, {
                active: {$set: tmpState.items[tmpState.active.id]}
            })

        case UserActions.RESET_ACTIVE_USER:
            return update(state, {
                active: {$set: undefined}
            })

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/UsersReducer.js